<template lang="pug">
  div.disclaimer
    h3.heading Important
    ul
      li {{ $t('disclaimer.leadTime') }}
      li {{ $t('disclaimer.manufacturing') }}
      li {{ $t('disclaimer.email') }}
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';
  .disclaimer {
    color: $dark-gray;
    padding: 0;
    margin-top: 2em;
  }

  .heading {
    text-transform: uppercase;
    margin-bottom: 1em;
    font-size: 1.1em;
    font-weight: 600;
    color: $blue;
  }

  ul {
    list-style-type: circle;
    margin-left: 20px;
    margin-bottom: 2em;
    line-height: 22px;
    font-size: 14px;
    font-weight: 600;
  }

</style>
